"use client";

import HelpContactCard from "@/components/help/HelpContactCard";
import HelpRequestForm from "@/components/help/HelpRequestForm";
import { useLocale } from "next-intl";

function Icon({ name, className = "", fill = false }: { name: string; className?: string; fill?: boolean }) {
  return <span className={`material-symbols-outlined ${fill ? "fill" : ""} ${className}`}>{name}</span>;
}

export default function ContactClient() {
  const locale = useLocale();
  const isAr = locale === "ar";
  const t = (a: string, e: string) => (isAr ? a : e);

  return (
    <div className="najdi bg-background text-ink-900 min-h-screen" dir={isAr ? "rtl" : "ltr"}>
      {/* Hero */}
      <section className="bg-clay-600 text-white">
        <div className="container mx-auto px-6 py-14 md:py-20 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/15 mb-5">
            <Icon name="support_agent" fill className="text-3xl" />
          </div>
          <h1 className="font-display text-3xl md:text-5xl font-extrabold mb-3">{t("تواصل معنا", "Contact us")}</h1>
          <p className="text-white/85 max-w-xl mx-auto">
            {t("فريق منازل الدرعية جاهز لمساعدتك والإجابة عن استفساراتك في أي وقت.", "The Diriyah Homes team is ready to help and answer your questions anytime.")}
          </p>
        </div>
      </section>

      {/* Info + form */}
      <section className="container mx-auto px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,340px)_1fr] gap-6 items-start">
          <HelpContactCard isAr={isAr} />
          <HelpRequestForm isAr={isAr} />
        </div>
      </section>
    </div>
  );
}
